const common = {
  Test: 'Test',
  Save: 'บันทึก',
  Download: 'Download',
  Cancel: 'Cancel',
  Export: 'Export',
  Import: 'Import',
  OK: 'OK',
};

export default common;
